import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { PrioritiesSection } from '../components/PrioritiesSection';
import { VideosSection } from '../components/VideosSection';
import { GetInvolvedSection } from '../components/GetInvolvedSection';
import { Footer } from '../components/Footer';
import { campaignData, handleDonation, handleVolunteer, handleNewsletter } from '../mock/campaignData';
import { useToast } from '../hooks/use-toast';

const CampaignHome = () => {
  const { toast } = useToast();

  const scrollToGetInvolved = () => {
    const element = document.getElementById('get-involved');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const onDonate = (amount) => {
    handleDonation(amount);
    toast({
      title: "Redirecting to donation page...",
      description: "Opening secure payment page in new window.",
    });
  };

  const onVolunteer = (formData) => {
    handleVolunteer(formData);
  };

  const onNewsletterSignup = (email) => {
    handleNewsletter(email);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header 
        logo={campaignData.candidate.logo} 
        onDonateClick={scrollToGetInvolved}
      />
      
      <main className="pt-20">
        <HeroSection 
          data={campaignData}
          onDonateClick={scrollToGetInvolved}
          onVolunteerClick={scrollToGetInvolved}
        />
        
        <AboutSection data={campaignData} />
        
        <PrioritiesSection data={campaignData} />
        
        <VideosSection />
        
        <GetInvolvedSection 
          onDonate={onDonate}
          onVolunteer={onVolunteer}
          onNewsletter={onNewsletterSignup}
        />
      </main>
      
      <Footer data={campaignData} />
    </div>
  );
};

export default CampaignHome;
